import type { SizerRepository } from '../../domain/interfaces/SizerRepository';

export type SizerService = ReturnType<typeof createSizerService>;

export function createSizerService(repo: SizerRepository) {
  return {
    isSizerEnabled() {
      return repo.isSizerEnabled();
    },
    fetchStates(countryId?: number) {
      return repo.fetchStates(countryId);
    },
    lookupPincode(pincode: string) {
      return repo.lookupPincode(pincode);
    },
    bookProductSizer(
      ...args: Parameters<SizerRepository['bookProductSizer']>
    ) {
      return repo.bookProductSizer(...args);
    },
    sendOtp(...args: Parameters<SizerRepository['sendOtp']>) {
      return repo.sendOtp(...args);
    },
    verifyOtp(...args: Parameters<SizerRepository['verifyOtp']>) {
      return repo.verifyOtp(...args);
    },
  };
}
